import * as products from './products'

export default products
